import { Calendar, ClipboardList, Settings, Users, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getPointeuseShowSessions } from '@/services/config.services';
import { Header } from '@/components/global/Header';
import { Footer } from '@/components/global/Footer';
import { useLateSessions } from '@/hooks/useSessions';

const navItems = [
    {
      label: 'Pointages',
      icon: Calendar,
      to: '/sessions',
      description: 'Historique des sessions',
      color: 'bg-sky-700 text-white border border-white/80',
    },
    {
      label: 'Pointeuse',
      icon: Clock,
      to: '/pointeuse',
      description: 'Pointer arrivée / départ',
      color: 'bg-primary text-primary-foreground border border-white/80',
    },
    {
      label: 'Planning',
      icon: ClipboardList,
      to: '/planning',
      description: 'Voir le planning de la semaine',
      color: 'bg-teal-700 text-white border border-white/80',
    },
    {
      label: 'Employés',
      icon: Users,
      to: '/employes',
      description: 'Gestion du personnel',
      color: 'bg-slate-700 text-white border border-white/80',
    },
    {
      label: 'Paramètres',
      icon: Settings,
      to: '/settings',
      description: 'Configuration de l appareil',
      color: 'bg-zinc-700 text-white border border-white/80',
    },
  ];

export const Home = () => {
    const showPointagesTile = getPointeuseShowSessions();

    // Employés qui n'ont pas dépointé selon leur planning
    const { data: lateSessions = [] } = useLateSessions();
    const lateCount = lateSessions.length;

    const visibleNavItems = navItems.filter((item) => {
      if (item.to === "/sessions") return showPointagesTile;
      return true;
    });

    return (
        <div className="h-full flex flex-col overflow-hidden bg-gray-50">
            <Header />
            {/* Navigation Grid */}
            <main className="flex-1 flex items-center justify-center px-6 pb-4">
                <div className="w-full max-w-4xl text-center">
                    <div className="flex flex-wrap justify-center gap-4 sm:gap-5 w-full max-w-3xl mx-auto">
                        {visibleNavItems.map((item) => {
                            const isPointages = item.to === '/sessions';

    const isPointeuse = item.to === '/pointeuse';

                            return (
                              <Link

                              key={item.to}
                  
                              to={item.to}
                  
                              className={`
                  
                                  relative
                  
                                  ${item.color}
                  
                                  ${
                  
                                    isPointeuse
                  
                                      ? 'basis-full sm:basis-[70%] max-w-[280px] min-h-[160px] scale-105'
                  
                                      : 'basis-[calc(50%-0.5rem)] sm:basis-[calc(33.333%-0.85rem)] max-w-[220px] min-h-[140px]'
                  
                                  }
                  
                                  rounded-2xl p-5
                  
                                  flex flex-col items-center justify-center gap-2
                  
                                  shadow-md hover:shadow-lg hover:-translate-y-0.5 hover:scale-[1.03]
                  
                                  active:scale-[0.98] transition-all duration-200
                  
                              `}
                  
                          >
                                    {/* Badge : employés en retard selon le planning */}
                                    {isPointages && lateCount > 0 && (
                                        <span className="absolute -top-2 -right-2 min-w-[22px] h-[22px] px-1.5 rounded-full bg-red-500 text-white text-xs font-bold flex items-center justify-center shadow-md ring-2 ring-white">
                                            {lateCount}
                                        </span>
                                    )}

                                    <div className="bg-white/15 rounded-xl p-3">
                                        <item.icon className="h-7 w-7" />
                                    </div>
                                    <span className="font-semibold text-center text-base sm:text-lg">
                                        {item.label}
                                    </span>
                                    {item.description ? (
                                        <span className="text-xs text-center opacity-90">
                                            {item.description}
                                        </span>
                                    ) : null}
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};
